unit UEssentialHelper;

interface

uses
  WebLib.Forms, UColorConfig, Classes, WebLib.ExtCtrls;

const
  B2HConvert: array [0 .. 15] of Char = ('0', '1', '2', '3', '4', '5', '6', '7',
    '8', '9', 'A', 'B', 'C', 'D', 'E', 'F');

type
  TModelKind = (mkUnknown, mkStamp, mkPicture);
  TJobKind = (jkUnknown, jkInsert);
  TAttachmentKind = (akUnknown, akPicture, akComment, akPdf);
  TStampArt = (saAll, saWithoutVM, saVM);

  TCallback = procedure(Sender: TObject) of object;
  TErrorEvent = procedure(Sender: TObject; AMsg: string) of object;
  TSnapshotEvent = procedure(Sender: TObject; Filename: string;
    Kind: TAttachmentKind) of object;
  TPropertyChangedEvent = procedure(Sender: TObject; PropertyName: string)
    of object;
  TListChangedEvent = procedure(Sender: TObject) of object;


  TBooleanValue = class
  private
    FValue: Boolean;
  public
    constructor Create(Value: Boolean);
    property Value: Boolean read FValue write FValue;
  end;

function ArtToStatus(Art: string): string;
function StrToBoolean(Value: string): Boolean;
function BerEinheitToEinheit(Value: string): string;
function BooleanToStr(Value: Boolean): string;
function PriorMonth(Value: TDateTime): TDateTime;
function Cut(var Value: string; cutChar: string = #9): string;
function DecodeClockInStr(Value: string): string;
function BuArtToStr(Value: string): string;
function GetDisabledBuArts(Value: string): string;
function AlignCenter(Value: string; color: string = '';
  fontColor: string = ''): string;
function AlignLeft(Value: string; color: string = '';
  fontColor: string = ''): string;
function AlignRight(Value: string): string;
function Bold(Value: string): string;
function ConvertToDecimal(Value: string): string;
function WeekDay(Value: Integer): string;
function MonthToStr(Value: Integer): string;
function IndexOfWeekDay(Value: string): Integer;
function RgbColorToHtmlColor(Value: Integer): string;
function CalcFontColor(color: Integer): string;
function HexCharToInt(Value: string): Integer;
function StatusToColor(status: Integer): string;
function StatusToFontColor(status: Integer): string;
function ContainsElement(element: string; lst: TStringList): Boolean;
function ModelKindToStr(Kind: TModelKind): string;
function StrToModelKind(Value: string): TModelKind;
function JobKindToStr(Kind: TJobKind): string;
function StrToJobKind(Value: string): TJobKind;
function Base64ToHex(Value: string): string;
function BinToHex(buf: TArray<Byte>): string;
function DateTimesAreEqual(Value1: TDateTime; Value2: TDateTime): Boolean;
function HexToBase64(Value: string): string;
function HexToBin(Value: string): TArray<Byte>;
function H2BConvert(Value: Char): Byte;
function Less(Art1: string; Art2: string): Boolean;
function AttachmentKindToStr(Kind: TAttachmentKind): string;
function StrToAttachmentKind(Value: string): TAttachmentKind;
function AlignTop(Value: string): string;
function TryStrToFloat(Value: string; var FloatValue: Double): Boolean;
function StampArtToStr(Value: TStampArt): string;
function StrToStampArt(Value: string): TStampArt;
procedure ColorComponents(frm: TForm; config: TColorConfig);
procedure FormatImage(Image: TImageControl; AWidth: Integer;
  AHeight: Integer);

implementation

uses
  System.SysUtils, System.DateUtils, WebLib.Buttons, WebLib.ComCtrls, Math,
  WebLib.WebCtrls, System.NetEncoding;

{ TBooleanValue }

constructor TBooleanValue.Create(Value: Boolean);
begin
  Self.Value := Value;
end;

function ArtToStatus(Art: string): string;
begin
  if Art = 'KO' then
    Result := 'Anwesend'
  else if Art = 'GE' then
    Result := 'Abwesend'
  else if Art = 'PA' then
    Result := 'In der Pause'
  else if Art = 'PE' then
    Result := 'Anwesend'
  else if Art = 'DA' then
    Result := 'Auf Dienstgang'
  else if Art = 'DE' then
    Result := 'Anwesend'
  else if Art = 'KA' then
    Result := 'Beim Arzt'
  else if Art = 'KE' then
    Result := 'Anwesend'
  else
    Result := 'Unbekannt'
end;

function StrToBoolean(Value: string): Boolean;
begin
  Result := LowerCase(Value) = 'true';
end;

function BerEinheitToEinheit(Value: string): string;
begin
  Value := UpperCase(Value);
  if Value = 'D' then
    Result := 'Tag(e)'
  else if Value = 'E' then
    Result := '€'
  else if Value = 'K' then
    Result := 'km'
  else if Value = 'R' then
    Result := 'Tag(e)'
  else if Value = 'S' then
    Result := 'h'
  else if Value = 'T' then
    Result := 'h'
  else
    Result := '';
end;

function BooleanToStr(Value: Boolean): string;
begin
  if Value then
    Result := 'true'
  else
    Result := 'false';
end;

function PriorMonth(Value: TDateTime): TDateTime;
begin
  Value := StartOfTheMonth(Value);
  Result := Value - 1;
end;

procedure ColorComponents(frm: TForm; config: TColorConfig);
var
  i: Integer;
begin
  for i := 0 to frm.ComponentCount - 1 do
  begin
    if frm.Components[i] is TPanel then
      (frm.Components[i] as TPanel).color := config.BackgroundColor
    else if frm.Components[i] is TBitBtn then
      (frm.Components[i] as TBitBtn).color := config.ButtonColor
    else if frm.Components[i] is TSplitter then
      (frm.Components[i] as TSplitter).color := config.BackgroundColor
    else if frm.Components[i] is TRichEdit then
      (frm.Components[i] as TRichEdit).color := config.BackgroundColor;
  end;
end;

function Cut(var Value: string; cutChar: string = #9): string;
var
  p: Integer;
begin
  p := Pos(cutChar, Value);
  if p > 0 then
  begin
    Result := Copy(Value, 1, p - 1);
    Delete(Value, 1, p + Length(cutChar) - 1);
  end
  else
  begin
    Result := Value;
    Value := '';
  end;
end;

function DecodeClockInStr(Value: string): string;
var
  s0, s1, t0, t1: string;
begin
  s0 := Cut(Value, '/');
  s1 := Cut(Value, ' ');
  t0 := BuArtToStr(s0);
  t1 := BuArtToStr(s1);
  if s0 <> t0 then
    Result := s0 + ' - ' + t0 + #9
  else
    Result := s0 + ' - ' + Value + ' beginnen' + #9;
  if s1 <> t1 then
    Result := Result + s1 + ' - ' + t1
  else
    Result := Result + s1 + ' - ' + Value + ' beenden';
end;

function BuArtToStr(Value: string): string;
begin
  if UpperCase(Value) = 'KO' then
    Result := 'Kommen'
  else if UpperCase(Value) = 'GE' then
    Result := 'Gehen'
  else if UpperCase(Value) = 'PA' then
    Result := 'Pause beginnen'
  else if UpperCase(Value) = 'PE' then
    Result := 'Pause beenden'
  else if UpperCase(Value) = 'DA' then
    Result := 'Dienstgang beginnen'
  else if UpperCase(Value) = 'DE' then
    Result := 'Dienstgang beenden'
  else if UpperCase(Value) = 'KA' then
    Result := 'Arztbesuch beginnen'
  else if UpperCase(Value) = 'KE' then
    Result := 'Arztbesuch beenden'
  else if UpperCase(Value) = 'AA' then
    Result := 'Neuen Auftrag starten'
  else if UpperCase(Value) = 'AE' then
    Result := 'Auftrag beenden'
  else
    Result := UpperCase(Value);
end;

function GetDisabledBuArts(Value: string): string;
begin
  if UpperCase(Value) = 'KO' then
    Result := 'KO,PE,KE,DE'
  else if UpperCase(Value) = 'GE' then
    Result := 'GE,PA,PE,KA,KE,DA,DE'
  else if UpperCase(Value) = 'PA' then
    Result := 'KO,GE,PA,KA,KE,DA,DE'
  else if UpperCase(Value) = 'PE' then
    Result := 'KO,PE,KE,DE'
  else if UpperCase(Value) = 'KA' then
    Result := 'KO,GE,PA,PE,KA,DA,DE'
  else if UpperCase(Value) = 'KE' then
    Result := 'KO,PE,KE,DE'
  else if UpperCase(Value) = 'DA' then
    Result := 'KE,GE,PA,PE,KA,KE,DA'
  else if UpperCase(Value) = 'DE' then
    Result := 'KO,PE,KE,DE'
  else
    Result := '';
end;

function AlignRight(Value: string): string;
begin
  Result := '<div style="text-align:right;">' + Value + '</div>';
end;

function Bold(Value: string): string;
begin
  Result := '<b>' + Value + '</b>';
end;

function ConvertToDecimal(Value: string): string;
var
  neg: Boolean;
  h, m: Integer;
  d: Double;
begin
  Result := '';
  if Value <> '' then
  begin
    neg := Value[1] = '-';
    if neg then
      Delete(Value, 1, 1);
    if Pos(':', Value) > 0 then
    begin
      h := StrToInt(Cut(Value, ':'));
      m := StrToInt(Cut(Value, ':'));
      d := h + (m / 60);
      Result := Format('%.2n', [d]);
    end
    else
      Result := Value;
    if neg then
      Result := '-' + Result;
  end;
end;

function AlignCenter(Value: string; color: string = '';
  fontColor: string = ''): string;
begin
  if (color = '') and (fontColor = '') then
    Result := '<div style="text-align:center;">' + Value + '</div>'
  else if (color <> '') and (fontColor = '') then
    Result := '<div style="text-align:center;background-color:' + color + '">' +
      Value + '</div>'
  else if (color = '') and (fontColor <> '') then
    Result := '<div style="text-align:center;color:' + fontColor + '">' + Value
      + '</div>'
  else if (color <> '') and (fontColor <> '') then
    Result := '<div style="text-align:center;background-color:' + color +
      ';color:' + fontColor + '">' + Value + '</div>'
end;

function AlignLeft(Value: string; color: string = '';
  fontColor: string = ''): string;
begin
  if (color = '') and (fontColor = '') then
    Result := Value
  else if (color <> '') and (fontColor = '') then
    Result := '<div style="background-color:' + color + '">' + Value + '</div>'
  else if (color = '') and (fontColor <> '') then
    Result := '<div style="color:' + fontColor + '">' + Value + '</div>'
  else if (color <> '') and (fontColor <> '') then
    Result := '<div style="background-color:' + color + ';color:' + fontColor +
      '">' + Value + '</div>'
end;

function WeekDay(Value: Integer): string;
begin
  Value := Value mod 7;
  case Value of
    0:
      Result := 'So.';
    1:
      Result := 'Mo.';
    2:
      Result := 'Di.';
    3:
      Result := 'Mi.';
    4:
      Result := 'Do.';
    5:
      Result := 'Fr.';
    6:
      Result := 'Sa.';
  end;
end;

function MonthToStr(Value: Integer): string;
begin
  Value := Value mod 12;
  case Value of
    0:
      Result := 'Jan';
    1:
      Result := 'Feb';
    2:
      Result := 'Mrz';
    3:
      Result := 'Apr';
    4:
      Result := 'Mai';
    5:
      Result := 'Jun';
    6:
      Result := 'Jul';
    7:
      Result := 'Aug';
    8:
      Result := 'Sep';
    9:
      Result := 'Okt';
    10:
      Result := 'Nov';
    11:
      Result := 'Dez';
  end;
end;

function IndexOfWeekDay(Value: string): Integer;
begin
  if Value = 'So' then
    Result := 0
  else if Value = 'Mo' then
    Result := 1
  else if Value = 'Di' then
    Result := 2
  else if Value = 'Mi' then
    Result := 3
  else if Value = 'Do' then
    Result := 4
  else if Value = 'Fr' then
    Result := 5
  else if Value = 'Sa' then
    Result := 6
  else
    Result := -1;
end;

function RgbColorToHtmlColor(Value: Integer): string;
var
  helper: string;
begin
  helper := IntToHex(Value, 6);
  if Length(helper) > 6 then
    Delete(helper, 1, Length(helper) - 6);
  Result := '#' + Copy(helper, 5, 2) + Copy(helper, 3, 2) + Copy(helper, 1, 2);
end;

function CalcFontColor(color: Integer): string;
var
  helper: string;
  g: UInt8;
begin
  helper := RgbColorToHtmlColor(color);
  Delete(helper, 1, 1);
  // r:=HexCharToInt(helper[1])*16+HexCharToInt(helper[2]);
  g := HexCharToInt(helper[3]) * 16 + HexCharToInt(helper[4]);
  // b:=HexCharToInt(helper[5])*16+HexCharToInt(helper[6]);
  if g <= 128 then
    Result := 'white'
  else
    Result := 'black';
end;

function HexCharToInt(Value: string): Integer;
var
  ch: Char;
  i: Byte;
begin
  Result := 0;
  if Length(Value) = 1 then
  begin
    Value := UpperCase(Value);
    i := Ord(Value[1]);
    ch := Chr(i);
    if ch in ['0' .. '9'] then
      Result := StrToInt(Value[1])
    else if UpperCase(Value[1]) = 'A' then
      Result := 10
    else if UpperCase(Value[1]) = 'B' then
      Result := 11
    else if UpperCase(Value[1]) = 'C' then
      Result := 12
    else if UpperCase(Value[1]) = 'D' then
      Result := 13
    else if UpperCase(Value[1]) = 'E' then
      Result := 14
    else if UpperCase(Value[1]) = 'F' then
      Result := 15
    else
      Result := 0;
  end;
end;

function StatusToColor(status: Integer): string;
begin
  Result := 'white';
  case status of
    0:
      Result := '#FFFF00';
    1:
      Result := '#FF8040';
    2:
      Result := '#008000';
    3:
      Result := '#FF0000';
    4:
      Result := '#0000FF';
  end;
end;

function StatusToFontColor(status: Integer): string;
begin
  Result := 'black';
  case status of
    0:
      Result := 'black';
    1:
      Result := 'black';
    2:
      Result := 'white';
    3:
      Result := 'white';
    4:
      Result := 'white';
  end;
end;

function ContainsElement(element: string; lst: TStringList): Boolean;
var
  i: Integer;
  s, t: string;
begin
  Result := false;
  i := 0;
  while not Result and (i < lst.Count) do
  begin
    s := lst[i];
    t := Cut(s, '/');
    Result := t = element;
    if not Result then
    begin
      t := Cut(s, ' ');
      Result := t = element;
    end;
    Inc(i);
  end;
end;

function ModelKindToStr(Kind: TModelKind): string;
begin
  case Kind of
    mkUnknown:
      Result := 'unbekannt';
    mkStamp:
      Result := 'TStampModel';
    mkPicture:
      Result := 'TPictureModel';
  end;
end;

function StrToModelKind(Value: string): TModelKind;
begin
  if Value = 'TStampModel' then
    Result := mkStamp
  else if Value = 'TPictureModel' then
    Result := mkPicture
  else
    Result := mkUnknown;
end;

function JobKindToStr(Kind: TJobKind): string;
begin
  case Kind of
    jkUnknown:
      Result := 'unbekannt';
    jkInsert:
      Result := 'Insert';
  end;
end;

function StrToJobKind(Value: string): TJobKind;
begin
  if Value = 'Insert' then
    Result := jkInsert
  else
    Result := jkUnknown;
end;

procedure FormatImage(Image: TImageControl; AWidth: Integer;
  AHeight: Integer);
var
  w1, w2, h1, h2: Integer;
begin
  w2 := AWidth;
  h2 := AHeight;;
  w1 := Image.ImageWidth;
  h1 := Image.ImageHeight;
  if (w1 > 0) and (h1 > 0) then
  begin
    if AWidth <= AHeight then
    begin
      AHeight := Round((AWidth * h1) / w1);
      if AHeight > h2 then
      begin
        AHeight := h2;
        AWidth := Round((AHeight * w1) / h1);
      end;
    end
    else
    begin
      AWidth := Round((AHeight * w1) / h1);
      if AWidth > w2 then
      begin
        AWidth := w2;
        AHeight := Round((AWidth * h1) / w1);
      end;
    end;
    Image.Width := AWidth;
    Image.Height := AHeight;
  end;
end;

function Base64ToHex(Value: string): string;
var
  buf: TArray<Byte>;
begin
  Result := '';
  if Value <> 'data:,' then
  begin
    Result := TNetEncoding.Base64.Decode(Value);
    buf := TEncoding.ASCII.GetBytes(Result);
    Result := BinToHex(buf);
  end;
end;

function BinToHex(buf: TArray<Byte>): string;
var
  i: Integer;
begin
  Result := '';
  for i := 0 to Length(buf) - 1 do
  begin
    Result := Result + B2HConvert[buf[i] shr 4];
    Result := Result + B2HConvert[buf[i] and $0F];
  end;
end;

function DateTimesAreEqual(Value1: TDateTime; Value2: TDateTime): Boolean;
var
  s1, s2: string;
begin
  s1 := FormatDateTime('yyyymmddhhnnss', Value1);
  s2 := FormatDateTime('yyyymmddhhnnss', Value2);
  Result := s1 = s2;
end;

function HexToBase64(Value: string): string;
var
  buf: TArray<Byte>;
begin
  buf := HexToBin(Value);
  Result := TEncoding.ASCII.GetString(buf);
  Result := TNetEncoding.Base64.Encode(Result);
end;

function HexToBin(Value: string): TArray<Byte>;
var
  i: Integer;
  b1, b2: Byte;
begin
  if Length(Value) mod 2 = 0 then
  begin
    SetLength(Result, Length(Value) div 2);
    for i := 0 to Length(Result) - 1 do
    begin
      b1 := H2BConvert(Value[(i * 2) + 1]);
      b2 := H2BConvert(Value[(i + 1) * 2]);
      Result[i] := (b1 shl 4) + b2;
    end;
  end;
end;

function H2BConvert(Value: Char): Byte;
begin
  if Value = '0' then
    Result := 0
  else if Value = '1' then
    Result := 1
  else if Value = '2' then
    Result := 2
  else if Value = '3' then
    Result := 3
  else if Value = '4' then
    Result := 4
  else if Value = '5' then
    Result := 5
  else if Value = '6' then
    Result := 6
  else if Value = '7' then
    Result := 7
  else if Value = '8' then
    Result := 8
  else if Value = '9' then
    Result := 9
  else if Value = 'A' then
    Result := 10
  else if Value = 'B' then
    Result := 11
  else if Value = 'C' then
    Result := 12
  else if Value = 'D' then
    Result := 13
  else if Value = 'E' then
    Result := 14
  else if Value = 'F' then
    Result := 15
  else
    Result := 0;
end;

function Less(Art1: string; Art2: string): Boolean;
begin
  Result := false;
  if ((Art1 = 'KO') and (Art2 = 'AA')) or ((Art1 = 'AE') and (Art2 = 'AA')) or
    ((Art1 = 'AE') and (Art2 = 'GE')) or ((Art1 = 'GE') and (Art2 = 'KO')) then
    Result := true;
end;

function AttachmentKindToStr(Kind: TAttachmentKind): string;
begin
  case Kind of
    akUnknown:
      Result := 'unbekannt';
    akPicture:
      Result := 'Picture';
    akComment:
      Result := 'Comment';
    akPdf:
      Result := 'PDF';
  end;
end;

function StrToAttachmentKind(Value: string): TAttachmentKind;
begin
  if Value = 'Picture' then
    Result := akPicture
  else if Value = 'Comment' then
    Result := akComment
  else if Value = 'PDF' then
    Result := akPdf
  else
    Result := akUnknown;
end;

function AlignTop(Value: string): string;
begin
  Result := '<div style="vertical-align: text-top;">' + Value + '</div>';
end;

function TryStrToFloat(Value: string; var FloatValue: Double): Boolean;
var
  neg, reachKomma, error: Boolean;
  faktor: Integer;
  d: Double;
begin
  d := 0;
  Value := Trim(Value);
  Value := StringReplace(Value, '.', '', [rfReplaceAll]);
  if Value <> '' then
  begin
    neg := false;
    reachKomma := false;
    if Value[1] = '-' then
      neg := true;
    if (Value[1] = '-') or (Value[1] = '+') then
    begin
      Delete(Value, 1, 1);
      Value := Trim(Value);
    end;
    faktor := 10;
    error := false;
    while not error and (Length(Value) > 0) do
    begin
      if Value[1] in ['0' .. '9'] then
      begin
        if not reachKomma then
          d := (d * 10) + StrToInt(Value[1])
        else
        begin
          d := d + (StrToInt(Value[1]) / faktor);
          faktor := faktor * 10;
        end;
      end
      else if Value[1] = ',' then
        reachKomma := true
      else
        error := true;
      Delete(Value, 1, 1);
    end;
    Result := not error;
    if Result and neg then
      d := -1 * d;
  end
  else
    Result := false;
  FloatValue := d;
end;

function StampArtToStr(Value: TStampArt): string;
begin
  case Value of
    saAll:
      Result := 'alle';
    saWithoutVM:
      Result := 'ohneVM';
    saVM:
      Result := 'nurVM';
  end;
end;

function StrToStampArt(Value: string): TStampArt;
begin
  if Value = 'ohneVM' then
    Result := saWithoutVM
  else if Value = 'nurVM' then
    Result := saVM
  else
    Result := saAll;
end;

end.
